function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.375 18.75 L 1.25 18.75 L 1.25 1.25 L 9.375 1.25 C 9.71875 1.25 10 0.96875 10 0.625 C 10 0.28125 9.71875 0 9.375 0 L 0.625 0 C 0.28125 0 0 0.28125 0 0.625 L 0 19.375 C 0 19.71875 0.28125 20 0.625 20 L 9.375 20 C 9.71875 20 10 19.71875 10 19.375 C 10 19.03125 9.71875 18.75 9.375 18.75 Z M 9.375 18.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.820312 9.5625 L 15.507812 5.1875 C 15.261719 4.945312 14.867188 4.945312 14.625 5.1875 C 14.378906 5.4375 14.378906 5.835938 14.625 6.082031 L 17.875 9.378906 L 5 9.378906 C 4.65625 9.378906 4.375 9.664062 4.375 10.007812 C 4.375 10.359375 4.65625 10.640625 5 10.640625 L 17.875 10.640625 L 14.625 13.9375 C 14.378906 14.1875 14.378906 14.585938 14.625 14.828125 C 14.867188 15.078125 15.261719 15.078125 15.507812 14.828125 L 19.820312 10.457031 C 20.058594 10.210938 20.0625 9.804688 19.820312 9.5625 Z M 19.820312 9.5625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2dc2b18991da88120c49e6e85efeac9d.svg";
export { ForwardRef as ReactComponent };